module.exports = __webpack_public_path__ + "static/media/16.c8a071e1.jpg";